import {
  LocationAlarmCamera,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useMemo } from 'react';
import { TalkdownStep } from './sop-card-utils';
import { LiveTalkdownCard } from './LiveTalkdownCard';

interface Props {
  cameras: LocationAlarmCamera[];
  locationAlarmId: string;
  escalationId?: string;
  product?: UnifiedMonitoringProduct;
  disabled?: boolean;
  steps: TalkdownStep[];
  stepsDone: number;
  onSent: () => void;
  onSkip: () => void;
  onProceed: () => void;
}

export function StepLiveTalkdown(props: Props) {
  const { onSkip, onProceed, ...cardProps } = props;
  const { steps, stepsDone } = props;

  const activeStep: TalkdownStep | undefined = steps[stepsDone];

  return (
    <div className="space-y-3">
      <LiveTalkdownCard {...cardProps} />

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={onSkip}
          className="flex-1 justify-center"
        >
          Skip Talkdown
        </Button>
        <Button
          variant="primary"
          onClick={onProceed}
          disabled={!!activeStep}
          className="flex-1 justify-center"
        >
          Proceed
        </Button>
      </div>
    </div>
  );
}

export function useTalkdownCameras(
  alarmCameras: LocationAlarmCamera[]
): LocationAlarmCamera[] {
  return useMemo(() => {
    const byId = new Map<string, LocationAlarmCamera>();

    alarmCameras.forEach((cam) => {
      if (!byId.has(cam.id)) {
        byId.set(cam.id, cam);
      }
    });

    return [...byId.values()].sort(
      (a, b) => Number(b.isTalkdownEnabled) - Number(a.isTalkdownEnabled)
    );
  }, [alarmCameras]);
}

export default StepLiveTalkdown;
